<template>
  <div>
    <v-text-field
      :append-icon="eyeflag ? 'mdi-eye' : 'mdi-eye-off'"
      :type="eyeflag ? 'text' : 'password'"
      :label="label"
      placeholder="Enter Password"
      outlined
      dense
      v-on:keyup.enter="onEnter"
      prepend-inner-icon="mdi-security"
      class="input-group--focused"
      @click:append="eyeflag = !eyeflag"
      @click:prepend-inner="updatePassword"
      v-model="val"
      hide-details="auto"
      @input="updateDate()"
      :readonly="readonly"
      :disabled="disabled"
    ></v-text-field>
  </div>
</template>

<script>
export default {
  sync: ["value"],
  props: {
    readonly: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    label: { type: String, default: null },
    required: { type: Boolean, default: false },
    maxlength: { type: Number, default: null },
    minlength: { type: Number, default: 0 },
    pattern: { type: String, default: null },
    error: { type: String, default: null },
    id: { type: String, default: null },
    name: { type: String, default: null },
    value: { type: String, default: null },
    title: { type: String, default: null },
    type: { type: String, default: "password" },
    description: {},
    isGeneratePassword: { type: Boolean, default: false },
  },

  data() {
    return {
      val: this.value,
      errorText: "",
      eyeflag: false,
      rules: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  mounted() {
    this.updatePassword();
  },
  watch: {
    value(val) {
      this.val = val;
    },
    isGeneratePassword(val) {
      if (val) {
        this.eyeflag = true;
        this.val = this.generatePassword();
        this.updateDate();
      }
    },
  },
  methods: {
    updatePassword() {
      if (this.isGeneratePassword) {
        this.eyeflag = true;
        this.val = this.generatePassword();
        this.updateDate();
      }
    },
    generatePassword() {
      var password = Math.random() // Generate random number, eg: 0.123456
        .toString(36) // Convert  to base-36 : "0.4fzyo82mvyr"
        .slice(-5);

      return "Lm$" + password + "1";
    },
    onEnter() {
      this.$emit("onEnter");
    },
    updateDate() {
      this.$emit("input", this.val);
    },
    toggleInput() {
      if (this.eyeflag) {
        this.eyeflag = false;
      } else {
        this.eyeflag = true;
      }
    },
  },
};
</script>
<style>
.protect {
  border: 1px solid #ced4da;
  border-width: 1px 1px 1px 0px;

  padding: 5px;
  border-radius: 0px 5px 5px 0px;
}

.protect i {
  cursor: pointer;
}
</style>
